import { render, staticRenderFns } from "./caruselItem.vue?vue&type=template&id=98f2b17a&scoped=true&"
import script from "./caruselItem.vue?vue&type=script&lang=js&"
export * from "./caruselItem.vue?vue&type=script&lang=js&"
import style0 from "./caruselItem.vue?vue&type=style&index=0&id=98f2b17a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98f2b17a",
  null
  
)

export default component.exports